import _ from 'lodash';
import {
  SOCKET_CONNECTED_NOTIFICATIONS,
  SOCKET_DISCONNECTED_NOTIFICATIONS,
  SOCKET_EVENT_NOTIFICATIONS,
} from 'actions/RealTimeNotificationActions';
import {setVariables} from "actions/EditorActions";
import { Button } from 'react-bootstrap';
import { getDeviceType } from "cc-editor/components/actions/deviceType";
import { confirmAlert } from 'react-confirm-alert';
import React from "react";
import JSZip from "jszip";


const initialState = {
  isConnectedToNotifications: false,
  notifications: [],
  userNotifications: [],
  pending: false,
  latestNotification: undefined,
  goToData: {},
};

function handleButtonClick(downloadLink) {
  fetch(downloadLink)
    .then(response => response.blob())
    .then(blob => {
      const blobUrl = URL.createObjectURL(blob);
      const filename = getFilenameFromUrl(downloadLink);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', filename);
      link.click();
      URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Error downloading file:', error);
    });
}

function getFilenameFromUrl(url) {
  const path = url.split('/');
  return path.pop();
}

function downloadZip(fileLinks) {
  const zip = new JSZip();
  const promises = fileLinks.map(fileLink => {
    return fetch(fileLink)
      .then(response => response.blob())
      .then(blob => {
        zip.file(getFilenameFromUrl(fileLink), blob);
      })
      .catch(error => {
        console.error('Error adding files to ZIP:', error);
      });
  });

  // Wait for all files to download before generating the ZIP archive
  Promise.all(promises)
    .then(() => {
      return zip.generateAsync({ type: 'blob' });
    })
    .then(blob => {
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', 'Media.zip');
      link.click();
      URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Error creating ZIP:', error);
    });
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    /** initial connection to socket */
    case SOCKET_CONNECTED_NOTIFICATIONS: {
      return {
        ...state,
        isConnectedToNotifications: true,
      };
    }

    /** disconnect socket connection */
    case SOCKET_DISCONNECTED_NOTIFICATIONS: {
      return {
        ...state,
        isConnectedToNotifications: false,
      };
    }

    /** Initial notifications from database */
    case "GET_NOTIFICATIONS_FULFILLED": {
      return {
        ...state,
        notifications: payload?.list,
      };
    }

    /** realtime notifications from socket */
    case SOCKET_EVENT_NOTIFICATIONS: {
      const { event } = payload;
      if (event?.eventName === 'notifications') { // Ignore other events for this reducer
        return {
          ...state,
          notifications: [event?.payload, ...state.notifications],
          latestNotification: event?.payload
        };
      }
      return state;
    }

    /** set notification as read */
    case "SET_READ_FULFILLED": {
      return {
        ...state,
        notifications: state.notifications.map(notification =>
          notification.id === payload.id ? payload : notification
        ),
      };
    }

    /** set notification as read */
    case "SET_READ_AND_GO_TO": {
      return {
        ...state,
        goToData: {id: payload?.id},
      };
    }

    case "GET_USER_NOTIFICATIONS_PENDING": {
      return {
        ...state,
        pending: true
      };
    }

    case "GET_USER_NOTIFICATIONS_FULFILLED": {
      return {
        ...state,
        userNotifications: payload,
        pending: false
      };
    }

    case "CHANGE_STATUS": { // Todo CD-1440 still needed?
      if (payload === 'printing') {
        return {
          ...state,
        };
      }
      if (payload === 'previewing') {
        return {
          ...state,
        };
      }
      if (payload === 'exporting') {
        return {
          ...state,
        };
      }
      if (payload === 'accessible') {
        return {
          ...state,
        };
      }
      if (payload === 'video') {
        return {
          ...state,
        };
      }
    }

    case "GET_FILE_VIA_NOTIFICATION": {
      const shareFB = url => {
        if (navigator.share) {
          navigator
            .share({
              title: 'CreaCheck',
              url,
            })
            .then(() => {
              console.log('Thanks for sharing!');
            })
            .catch(console.error);
        } else {
          window.open(
            'https://www.facebook.com/sharer/sharer.php?u=' + url,
            'pop',
            'width=600, height=400, scrollbars=no'
          );
        }
      };

      const options = {
        customUI: ({ onClose }) => {
          return (
            <div className="react-confirm-alert-body">
              <h1>{payload?.messages.your_export}</h1>
              <p>{payload?.messages.file_export_request}</p>
              <div className="edition-download">
                {typeof payload?.files === 'string' && (
                  <>
                    <Button
                      variant="success"
                      onClick={() => {
                        handleButtonClick(payload?.files);
                        onClose();
                      }}
                    >
                      {payload?.messages.export_download}
                    </Button>
                    {(getDeviceType() === 'mobile' || getDeviceType() === 'tablet') && (payload.exportType === 'image' || payload.exportType === 'video') && (
                      <Button onClick={() => shareFB(payload?.data)}>
                        {payload?.messages.export_share}
                      </Button>
                    )}
                  </>
                )}
                {typeof payload?.files === 'object' && payload.files.length > 0 && (
                  <>
                    <Button
                      variant="success"
                      onClick={() => {
                        downloadZip(payload.files);
                        onClose();
                      }}
                    >
                      {payload?.messages.export_download + ' - ZIP'}
                    </Button>
                    {payload.data.map((file, i) => {
                      let count = i + 1;
                      return (
                        <>
                          <Button
                            onClick={() => {
                              handleButtonClick(file);
                            }}
                          >
                            {payload?.messages.export_download +
                              ' - ' + payload?.messages.export_file +
                              ' ' + count}
                          </Button>
                          {(getDeviceType() === 'mobile' || getDeviceType() === 'tablet') && payload.exportType === 'image' && (
                            <Button onClick={() => shareFB(file)}>{payload?.messages.export_share}</Button>
                          )}
                        </>
                      );
                    })}
                    <Button
                      variant="warning"
                      onClick={() => {
                        onClose();
                      }}
                    >
                      {payload?.messages.editor.abort}
                    </Button>
                  </>
                )}
              </div>
            </div>
          );
        },
        childrenElement: () => <div />,
        closeOnEscape: true,
        closeOnClickOutside: true,
      };
      confirmAlert(options);

      return { ...state, previewingR: false, printingR: false, accessibleR: false, exportingR: false, videoR: false, };
    }



    default:
      return state;
  }
};
